import {Button, Card, Stack} from "@mui/material"
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {useRouter} from "@/helper/hooks";

const notFound = "https://oss.kedaip.cn/keda/assets/404.png"

export const NotFoundPage = () => {
    const router = useRouter()
    // linear-gradient(#FFF 0%, #ebf5ff 100%)
    return <Card sx={{background: "#ebf5ff1a", width: "100%"}}>
        <Stack justifyContent={'center'} alignItems={'center'} height={'calc(100vh - 160px)'} alignContent={'center'}
               direction="column"
               rowGap={2}>
            <Box width={251} height={294} component={'img'} src={notFound}/>
            <Typography color={'textSecondary'} fontSize={12}>您访问的页面不存在</Typography>
            <Button onClick={() => router.replace('/')} variant='outlined' color={'secondary'}>返回首页</Button>
        </Stack>
    </Card>
}